import Button from "@app/components/move2Library/Button/Button"
import { Modal, useViewport } from "@tecreation/funnel-components"
import "./MyParadiseDeleteTransponderModal.css"

export const MyParadiseDeleteTransponderModal = ({ onClose, onDelete }) => {
	const { sm } = useViewport()

	return (
		<Modal>
			<Modal.Closer className="my-paradise-delete-transponder-modal-closer" onClick={onClose} />
			<Modal.Header className="my-paradise-delete-transponder-modal-header ml-0 mr-0">Transponder löschen?</Modal.Header>
			<Modal.Body className="my-paradise-delete-transponder-modal-body">Sicher das du deinen Transponder löschen möchtest?</Modal.Body>
			<Modal.Footer>
				<div className={sm ? "flex flex-column flex-align-center mt-4 mb-2" : "flex flex-justify-between"}>
					<Button style="danger" className={sm && "mb-3"} onClick={onDelete}>
						Löschen
					</Button>
					<Button style="primary" onClick={onClose}>
						Abbrechen
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}
